import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=6d02fe28&scoped=true"
import script from "./pageFooter.vue?vue&type=script&lang=js"
export * from "./pageFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d02fe28",
  null
  
)

export default component.exports